import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutsModule } from 'src/app/layout-views/layouts.module';
import { AuthGuardService } from 'src/app/services/auth-guard.service';
import { layoutModules, moduleRoot, formRoute } from 'src/app/services/component-pages.service';
import { LayoutAuthComponent } from 'src/app/layout-views/auth/auth.component';
import { LayoutMainComponent } from 'src/app/layout-views/main/main.component';

import { NotFoundComponent } from 'src/app/pages/auth/notfound/notfound.component';

const COMPONENTS = [NotFoundComponent];

function buildAppRoutes() {
  const appRoutes: Routes = [];
  appRoutes.push({ path: '', redirectTo: formRoute('DEFAULT'), pathMatch: 'full' });
  appRoutes.push(layoutModules('home')[0]);
  appRoutes.push({ ...layoutModules('auth')[0], component: LayoutAuthComponent });
  appRoutes.push({ path: '', canActivate: [AuthGuardService], component: LayoutMainComponent, children: layoutModules('main') });
  appRoutes.push({
    path: '**',
    component: LayoutAuthComponent,
    children: [{ path: '', component: NotFoundComponent, data: { title: 'Not Found' } }],
  });
  return appRoutes;
}

@NgModule({
  imports: [
    RouterModule.forRoot(buildAppRoutes(), {
      useHash: false,
      onSameUrlNavigation: 'ignore',
      enableTracing: false,
      scrollPositionRestoration: 'enabled',
      // relativeLinkResolution: 'corrected',
    }),
    LayoutsModule,
  ],
  providers: [],
  declarations: COMPONENTS,
  exports: [RouterModule],
})
export class AppRoutingModule { }
